import { useEffect, type ReactNode } from 'react';
import { useAccountInfo } from '../api/queryHooks/account';
import { applyThemeTokens, clearThemeTokens } from './applyTheme';
import { writeCachedTheme } from './themeCache';
import { useShopHead } from './useShopHead';

/**
 * Reconciles the live theme from /accounts/info with the pre-paint cache:
 * applies tokens to <html> and refreshes the localStorage cache. When the
 * account has no whitelabel theme, clears the cache so the shop reverts to the
 * default look and removes the CSS custom properties from the current session.
 *
 * The document title and icon links are not theming — useShopHead owns them
 * (they apply to every shop, whitelabel or not).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const { data } = useAccountInfo();
  const theme = data?.setting?.theme ?? null;

  useShopHead();

  useEffect(() => {
    if (theme) {
      applyThemeTokens(theme);
      writeCachedTheme(theme);
    } else {
      clearThemeTokens();
      writeCachedTheme(null);
    }
  }, [theme]);

  return <>{children}</>;
}
